import IntegerInput from "./IntegerInput";
import TextInput from "./TextInput";

import "./input.scss";

const inputByType = {
  integer: IntegerInput,
  text: TextInput,
} as any;

interface InputInterface {
  value: any;
  onChange: Function;
  type: string;
  label: JSX.Element | string;
  unit?: string;
  errorText?: string;
  className?: string;
}

function Input({
  type = "text",
  label,
  unit,
  errorText,
  className,
  value,
  onChange,
}: InputInterface) {
  const InputComponent = inputByType[type] ?? inputByType["text"];

  return (
    <div
      className={["input-wrapper", className, errorText ? "error" : undefined]
        .filter((e) => e)
        .join(" ")}
    >
      <label>{label}</label>
      <div className="input">
        <InputComponent value={value} onChange={onChange} />
        {unit && <span className="unit">{unit}</span>}
      </div>
      {errorText && <div className="input-error">{errorText}</div>}
    </div>
  );
}

export default Input;
